import { useState } from 'react'
import { COPY_FEEDBACK_MS } from '../../lib/config'

interface CopyButtonProps {
  text: string
  small?: boolean
  style?: React.CSSProperties
}

export function CopyButton({ text, small, style }: CopyButtonProps) {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    navigator.clipboard.writeText(text)
      .then(() => { setCopied(true); setTimeout(() => setCopied(false), COPY_FEEDBACK_MS) })
      .catch(() => {})
  }

  return (
    <button
      onClick={handleCopy}
      style={{
        padding: small ? '0.2rem 0.45rem' : '0.25rem 0.55rem',
        background: 'var(--bg-elevated)',
        border: '1px solid var(--border)',
        borderRadius: 5,
        color: copied ? 'var(--status-success)' : 'var(--text-muted)',
        fontSize: small ? '0.68rem' : '0.7rem',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        flexShrink: 0,
        transition: 'all 0.15s',
        fontFamily: 'inherit',
        ...style,
      }}
      onMouseEnter={e => { if (!copied) (e.currentTarget as HTMLElement).style.color = 'var(--text-primary)' }}
      onMouseLeave={e => { if (!copied) (e.currentTarget as HTMLElement).style.color = 'var(--text-muted)' }}
    >
      {copied ? '✓ Copied' : '📋 Copy'}
    </button>
  )
}
